import { HealthCenter, isUnitActiveAt } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { getHealthCenterUnitsQuery } from './get-health-center-units-query';

export const getHealthCenterUnitsQueryOptions = (healthCenter: HealthCenter) =>
  queryOptions({
    queryKey: [getHealthCenterUnitsQuery(healthCenter).className, getHealthCenterUnitsQuery(healthCenter).toJSON()],
    queryFn: async () => {
      // findAll refuse un tri : l'ordre alphabétique se fait après lecture.
      const units = await getHealthCenterUnitsQuery(healthCenter).findAll({ batchSize: 500 });
      const now = new Date();
      return units.filter((unit) => isUnitActiveAt(unit, now)).sort((a, b) => a.name.localeCompare(b.name));
    },
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
